
import React from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { CATEGORY_TRANSLATIONS } from '@/constants/menuTranslations';

interface MenuCategoryButtonsProps {
  categories: string[];
  activeCategory: string | null;
  onCategoryChange: (category: string) => void;
  menu: {
    primary_color?: string;
  };
}

const MenuCategoryButtons: React.FC<MenuCategoryButtonsProps> = ({
  categories,
  activeCategory,
  onCategoryChange,
  menu
}) => {
  return (
    <div className="sticky top-0 z-30 bg-white shadow-sm p-2 mt-4">
      <div className="w-full overflow-x-auto">
        <div className="flex gap-2 px-2 pb-2 min-w-max">
          {categories.map(category => (
            <button
              key={category}
              className={`px-3 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors flex-shrink-0 ${
                activeCategory === category 
                  ? 'bg-primary text-white' 
                  : 'bg-gray-100 hover:bg-gray-200'
              }`}
              style={{ 
                backgroundColor: activeCategory === category ? menu.primary_color : '',
                color: activeCategory === category ? 'white' : '' 
              }}
              onClick={() => onCategoryChange(category)}
            >
              {CATEGORY_TRANSLATIONS[category] || category}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MenuCategoryButtons;
